var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0-smiley-icon{fill:#001529;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.6,
    r: 10.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0-smiley-icon",
    d: "M17.3,12.9c-0.4-0.3-1.1-0.2-1.4,0.2c0,0-1.6,2-4.1,2c-2.5,0-4-2-4.1-2c-0.3-0.4-1-0.5-1.4-0.2 c-0.4,0.3-0.5,1-0.2,1.4c0.1,0.1,2.2,2.8,5.7,2.8s5.6-2.7,5.7-2.8C17.8,13.8,17.8,13.2,17.3,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-smiley-icon",
    d: "M8.2,10C9,10,9.7,9.3,9.7,8.5S9,7,8.2,7h0C7.4,7,6.7,7.6,6.7,8.5S7.4,10,8.2,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0-smiley-icon",
    d: "M15.5,10c0.8,0,1.5-0.7,1.5-1.5S16.3,7,15.5,7h0C14.7,7,14,7.6,14,8.5S14.7,10,15.5,10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyIcon);
export default __webpack_public_path__ + "static/media/SmileyIcon.5b0229f07ebfbefa8d379cbcf700f9ff.svg";
export { ForwardRef as ReactComponent };